module.exports = __webpack_public_path__ + "img/imageDefoult.5350236a.jpg";